import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';
import { StyledFilters, StyledFiltersOptions } from './Filters.style';
import useFilters from './useFilters';
import { FilterSetButtons } from '../FilterSet/FilterSetButtons';
import FilterSetWrapper from './FilterSetView/FilterSetWrapper';
import useUiRefByKey from '../../../hooks/useUiRefByKey';
import { FILTERS_PROVIDER_UI_REFS } from '../../../consts';
import { LBArrowRightIcon, LBButton } from '@linearb/buzz';

const Filters = ({ Context }) => {
  const {
    localFilters,
    menuItems,
    onChange,
    onApply,
    onDelete,
    hasFiltersChanged
  } = useFilters({ Context });
  const triggerMenuButtonRef = useUiRefByKey(
    Context,
    FILTERS_PROVIDER_UI_REFS.TRIGGER_FILTER_MENUS_BUTTON
  );

  return (
    <StyledFilters>
      <FilterSetWrapper Context={Context}>
        <div className='flex flex-row gap-2 items-center justify-start'>
          {/* @ts-expect-error */}
          <FilterMenusV2
            menuItems={menuItems}
            selectedFilters={localFilters}
            setSelectedFilters={onChange}
            onDeleteFilter={onDelete}
            triggerMenuButtonRef={triggerMenuButtonRef}
          >
            <LBButton
              disabled={!hasFiltersChanged}
              onClick={onApply}
              data-cy='filter-set-bar-apply-filters-btn'
            >
              <LBArrowRightIcon /> Apply Filters
            </LBButton>
          </FilterMenusV2>
        </div>
      </FilterSetWrapper>

      <StyledFiltersOptions>
        <FilterSetButtons Context={Context} />
      </StyledFiltersOptions>
    </StyledFilters>
  );
};

export default Filters;
